import { DAY_MS, MINUTE_MS } from '@anm/constants/date';
import MONTHS from '@anm/constants/months';
import getDateMonthYear from '@anm/helpers/date/getDateMonthYear';

export const getTableLabel = (dateMs: number) => {
  const [, month, year] = getDateMonthYear(dateMs);
  const monthStr = MONTHS[month];

  return `${monthStr} ${year}`;
};

export const getDays = (dateMs: number) => {
  const date = new Date(dateMs);
  const lastDate = new Date(date.getFullYear(), date.getMonth() + 1, 0);
  const firstDate = new Date(date.getFullYear(), date.getMonth(), 1);
  const lastMonthDay = lastDate.getDate();
  const firstMonthDay = firstDate.getDay();

  const datesFilled = [...Array(lastMonthDay)].map((_: number, index) => index + 1);
  const datesOffset = [...Array(firstMonthDay)];

  const newDates = [...datesOffset, ...datesFilled];

  const [, month, year] = getDateMonthYear(dateMs);
  const mappedDates = newDates.map((date: number) => {
    if (!date) return;

    return {
      label: date,
      value: new Date(year, month, date).getTime()
    };
  });

  return mappedDates;
};

const getDateLabel = (dateMs: number) => {
  const [date, monthIndex, year] = getDateMonthYear(dateMs);

  const month = MONTHS[monthIndex].slice(0, 3);

  return `${month} ${date}, ${year}`;
};

export const createLabel = (dates: number[]) => [...new Set(dates.map(date => getDateLabel(date)))].join(' – ');

export const getEndDate = (date: number) => date + DAY_MS - MINUTE_MS;
